import { getJSON, putFormJSON } from 'bv-fetch';
import { logged_account_id as accountId } from 'state';

export const getPreferences = () => getJSON('/bv_api/betting_api/account_settings', { l: accountId() });
export const submitPreferences = (content) => putFormJSON('/betting_settings', content);
